export const USER_ROLES = {
  ADMIN: "admin",
  LIMITED_ADMIN: "limited_admin",
  SALESMAN: "salesman",
  PERICIA_CREATOR: "pericia_creator",
  USER_PRIVILEGED: "user_privileged",
  USER: "user"
};
